module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To Lois – for believing in my journey.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To Dave – for tall persons hugs.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To Henry – for being my book champion and for asking me, ‘When will your book be published Aunty Becki?’")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To Savannah – who inspired the twins and is my ‘Katy’.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To anyone who knows what it’s like when life throws you a curved ball. Let that curved ball become your axis from which to spin something beautiful again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0